/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useParams} from 'react-router-dom'
// import HeaderCardConditioning from '../../../../../../components/Forms/HeaderCardConditioning'
import {AnimaFadeinTop} from '../../../../../../_metronic/assets/animation/styles'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {ActionPlans, ActionPlansInitValues} from '../../components/actionPlans-list/core/_models'
import {Vertical} from './editOneActionPlans/Vertical'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const EditActionPlans: FC = () => {
  const intl = useIntl()
  const {uuid, uuid2} = useParams()
  const [ActionPlans, setActionPlans] = useState<ActionPlans>(ActionPlansInitValues)

  useEffect(() => {
    if (uuid && uuid2) {
      getActionPlans(uuid)
    }
    // eslint-disable-next-line
  }, [])

  async function getActionPlans(uuid: string) {
    const {data} = await axios.get(
      API_URL + '/sga/v1/conditionings/' + uuid2 + '/action_plans/' + uuid
    )
    const ActionPlans: ActionPlans = data.data
    setActionPlans(ActionPlans)
    return data
  }

  return (
    <>
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />

      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({id: 'ACTION_PLANS.TITLE'}) +
          ' ' +
          (ActionPlans.id === undefined ? '' : ActionPlans.id)}
      </PageTitle>
      {/* Component Header de Cadastros. */}
      <AnimaFadeinTop>
        <div className='card-body px-2 py-0'>
          <div className='tab-content' id='myTabContent'>
            <div className='tab-pane fade active show' id='kt_tab_pane_1' role='tabpanel'>
              <Vertical data={ActionPlans} />
            </div>
          </div>
        </div>
      </AnimaFadeinTop>
    </>
  )
}

export {EditActionPlans}
